module.exports = __webpack_public_path__ + "img/robot.1a302563.svg";